module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/recommend_4_03-831eac8f1d2bb6c5c1e40a865c878c41.jpg";